import React from 'react';

const CloudIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries-large">
      <div className="vbz-icon-beneficiaries-large-cloud" />
    </div>
  );
};

export default CloudIcon;
